export const MemberTripConfig = {
    timer: {
        start: '2024/04/09 00:00:00 GMT+8',
        end: '2024/04/27 15:00:00 GMT+8',
    },
    includePaths: ['/delta-pro-ultra', '/smart-home-panel-2'],
    includeSites: ['us', 'ca'],
};

export const MemberTripText = {
    us: {
        title1: 'Exclusive EcoFlow Member Deal: ',
        title2: 'Order now and unlock $500 off! ',
        desc: '4.4-4.26, 2024',
        btn: 'Join and Save Now',
        link: 'By reviewing your EcoFlow journey, you agree to allow us to analyze how you use the EcoFlow app and appliances, as well as your data with EcoFlow from the past year. Please view our <a class="link" href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',
    },
    ca: {
        title1: 'Exclusive EcoFlow Member Deal: ',
        title2: 'Order now and unlock $500 off! ',
        desc: '4.4-4.26, 2024',
        btn: 'Join and Save Now',
        link: 'By reviewing your EcoFlow journey, you agree to allow us to analyze how you use the EcoFlow app and appliances, as well as your data with EcoFlow from the past year. Please view our <a class="link" href="https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',
    },
};
